import { ENDPOINTS_USER } from '../../config/';
import { localeData } from '../../locales/data';
import { BaseCreateAccountData } from '../../reducers/AccountReducer/AccountReducer.types';
import { webSimApiErrorFlashMessages } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';
import { addFlashMessages } from '../FlashMessagesActions';

import { responseAccountFailure } from './AccountActions';

export const getErrorMessagesArray = (msg: any, nestedKey: string) => {
  let errors: string[] = [];
  if (Array.isArray(msg)) {
    msg.forEach((value: string) => {
      if (value.includes('this field')) {
        errors = errors.concat(`${value.replace('this field', nestedKey)}`);
      } else if (value.includes('This field')) {
        errors = errors.concat(nestedKey ? `${value.replace('This field', nestedKey)}` : value);
      } else {
        errors = errors.concat(nestedKey ? `${nestedKey}: ${value}` : value);
      }
    });
    return errors;
  }

  if (typeof msg === 'object' && msg !== null) {
    Object.keys(msg).forEach((key: string) => {
      errors = errors.concat(getErrorMessagesArray(msg[key], key));
    });
    return errors;
  }

  // Base case: if msg is not an array or object, return it as a single-element array
  return !!msg ? [msg] : [];
};

export const createAccountfetch = async (data: BaseCreateAccountData): Promise<object> =>
  fetch(ENDPOINTS_USER.user, {
    method: 'POST',
    credentials: 'include',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(data),
  });

export const createAccountfetchErrors = async (
  json: any,
  dispatch: any,
  action = responseAccountFailure,
  showFlashMessage = true
): Promise<object> => {
  if (Object.keys(json).length === 0) {
    logErrorService(json, json);
    webSimApiErrorFlashMessages(dispatch);

    return dispatch(action());
  } else if (json.hasOwnProperty('detail')) {
    dispatch(addFlashMessages([{ msg: json.detail, defaultMessage: localeData.en[json.detail] }]));
    logErrorService(localeData.en[json.detail], localeData.en[json.detail]);

    return dispatch(action());
  } else {
    if (json) {
      logErrorService(json, json);
    }
    if (showFlashMessage) {
      dispatch(addFlashMessages(getErrorMessagesArray(json, ''), { intl: false }));
    }

    return dispatch(action(json));
  }
};

export const checkIfServerIsDown = async (dispatch: any, response: any, dispatchFailure: () => any, location?: any): Promise<object> => {
  if (response.status === 503) {
    logErrorService(localeData.en['api.error.brain.unavailable'], localeData.en['api.error.brain.unavailable']);
    dispatch(
      addFlashMessages(
        [
          {
            msg: 'api.error.brain.unavailable',
            defaultMessage: localeData.en['api.error.brain.unavailable'],
          },
        ],
        {
          context: 'generic',
          location,
        }
      )
    );

    return dispatchFailure();
  } else {
    webSimApiErrorFlashMessages(dispatch, 'generic', location);

    return dispatchFailure();
  }
};

export const setEditErrorMsg = (json: any) => {
  let errors: Object[] = [];

  if (json.hasOwnProperty('__serialized__')) {
    const nestedMsgKeys = ['employment', 'education', 'address', 'auxiliary', 'settings'];

    const msg = json.__serialized__;

    Object.keys(msg).forEach((key: string) => {
      if (nestedMsgKeys.indexOf(key) !== -1) {
        Object.keys(msg[key]).forEach((nestedKey: string) => {
          const messages: string[] = msg[key][nestedKey];
          messages.forEach((value: string) => {
            errors = errors.concat({
              msg: `The Field ${nestedKey} ${value.replace('This field ', '')}`,
              defaultMessage: localeData.en[`The Field ${nestedKey} ${value.replace('This field ', '')}`],
            });
          });
        });
      } else {
        Object.keys(msg).forEach((keyVal: string) => {
          const messages: string[] = msg[keyVal];
          messages.forEach((value: string) => {
            errors = errors.concat({
              msg: `The Field ${keyVal} ${value.replace('This field ', '')}`,
              defaultMessage: localeData.en[`The Field ${keyVal} ${value.replace('This field ', '')}`],
            });
          });
        });
      }
    });

    return errors;
  } else {
    return errors;
  }
};
